
import { call, cancel, cancelled, delay, fork, take } from 'redux-saga/effects'

import { checkSession } from './serverApi/security';

export const CHECK_SESSION_START_ACTION_TYPE = 'checkSession/START';
export const CHECK_SESSION_STOP_ACTION_TYPE = 'checkSession/STOP';

export default function getActions(dispatch) {
    return {
        checkSessionStart: (token) => dispatch({
            type: CHECK_SESSION_START_ACTION_TYPE,
            token,
        }),
        checkSessionStop: () => dispatch({
            type: CHECK_SESSION_STOP_ACTION_TYPE
        }),
    };
}

function* checkSessionTask(action) {
    try {
        while (true) {
            yield delay(10 * 60 * 1000);
            yield call(
                checkSession,
                {
                    token: action.token,
                }
            );
        }
    } finally {
        if (yield cancelled()) {
            console.log('checkSession is stopped');
        }
    }
}

export function* checkSessionWorkFlow() {
    while(true) {
        const action = yield take(CHECK_SESSION_START_ACTION_TYPE)
        const task = yield fork(checkSessionTask, action);
        yield take('CHECK_SESSION_STOP_ACTION_TYPE');
        yield cancel(task);
    }
}
